import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DownloadResultsModalComponent, type DownloadResultsModalProps,
} from './downloadResultsModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DownloadResults: DownloadResultsModalProps;
  }
}
modalRenderer.register('DownloadResults', DownloadResultsModalComponent);
